module.exports = "https://cdn-challenge.mathletics.com/app/275/assets/fonts/d873734390c716d6e18ff3f71ac6eb8b.woff2";